import { render, staticRenderFns } from "./SunsetLoginNotice.vue?vue&type=template&id=39600fe9&scoped=true&"
import script from "./SunsetLoginNotice.vue?vue&type=script&lang=js&"
export * from "./SunsetLoginNotice.vue?vue&type=script&lang=js&"
import style0 from "./SunsetLoginNotice.vue?vue&type=style&index=0&id=39600fe9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39600fe9",
  null
  
)

export default component.exports